import { type ComponentProps, memo } from 'react';

import { RarityCard } from '@/shared/components/ui/rarityCard';
import { Skeleton } from '@/shared/components/ui/skeleton';
import { cn } from '@/shared/utils/cn';

export interface DuoActivitySkeletonProps extends ComponentProps<'div'> {}

export const DuoActivitySkeleton = memo(function DuoActivitySkeleton(
  props: DuoActivitySkeletonProps,
) {
  const { className, ...rest } = props;

  return (
    <RarityCard.Outer
      {...rest}
      rarity="COMMON"
      className={cn('relative', className)}
    >
      <RarityCard.Inner className="flex flex-1 flex-col gap-0 overflow-x-hidden overflow-y-auto scroll-smooth">
        {/* Header Skeleton */}
        <div className="flex flex-col gap-4 px-2 pt-10 pb-2">
          <Skeleton className="h-24 w-full" />
        </div>

        <div className="bg-cold-950 flex flex-col gap-2 px-2 pt-4 pb-2">
          {/* Impact Rating Skeleton */}
          <Skeleton className="h-20 w-full rounded-lg" />

          {/* Stats Skeleton */}
          <Skeleton className="h-48 w-full rounded-lg" />

          {/* Agents Played Skeleton */}
          <Skeleton className="h-40 w-full rounded-lg" />
        </div>

        {/* Actions Skeleton */}
        <div className="bg-cold-950 sticky bottom-0 z-20 flex items-center gap-1 px-2 pt-4 pb-2">
          <Skeleton className="h-10 flex-1 rounded-lg" />
          <Skeleton className="h-10 flex-1 rounded-lg" />
          <Skeleton className="size-10 rounded-lg" />
          <Skeleton className="size-10 rounded-lg" />
        </div>
      </RarityCard.Inner>
    </RarityCard.Outer>
  );
});
